<template>
    <button class="pagination__button" :class="classButton" @click.prevent="clickButton">
        <div class="pagination__button_text" v-html="valueShow">
        </div>
    </button>
</template>

<script>

export default {
    name: "checkbox_custom",
    props: {
        buttonValue: {
            type: Number,
            required: false,
        },
        activeValue: {
            type: Number,
            required: true,
        }
    },
    data() {
        return {

        }
    },
    emits: ['click_number_page'],
    methods: {
        clickButton() {
            this.$emit('click_number_page', this.buttonValue);
        },
    },
    computed: {
        valueShow() {
            return `<span>${this.buttonValue}</span>`;
        },
        classButton() {
            if (this.buttonValue === this.activeValue) {
                return 'active';
            }
            return '';
        }
    },
}
</script>
